<template>
  <div class="credit-reform-container">
    <div class="container-top">
      <div class="main-title">完全学分制改革</div>
    </div>
    <div class="main-content">
      <div class="left-content" @click="playVideo">
        <video
          ref="videoPlayer"
          src="https://alivideo.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/05a32c9084904552bd7322f3212f3011.mp4"
          poster="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/4d1bc6700d084354a7f151349386224d.png"
        >
        </video>
        <div class="video-info" v-if="!isPlaying">
          <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/9632834a665946feb3b07c0bfdcd7d7c.png"/>
          <span>{{ currentTime>0 ? showTime : duration }}</span>
        </div>
      </div>
      <div class="right-content">
        <img class="right-icon" src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/ac8b52f57eb64cc399928db2f6d46ab5.png"/>
        <div class="right-title">海南大学：学在海大</div>
        <div class="right-text">过去四年来，学校坚持以促进学生的发展成长为核心，推行了以完全学分制为引领的“三大改革”。基于学生个性化培养与持续性成长考虑，按照学校2024年暑期工作会议“数字赋能、质量为先，全面系统深入推进三大改革”的战略部署，教务处牵头启动了深化完全学分制改革工作，通过进一步扩大学生学习自主权（自由选课、自主选择专业、自由安排学习进程），全面激发学生自我成长的内生动力，力求让每个来到海大的学生都能找到自己的舞台。</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const videoPlayer = ref(null)
const isPlaying = ref(false)
const currentTime = ref(0)
const duration = ref('03:56')

const showTime = computed(() => {
  const minutes = Math.floor(currentTime.value / 60)
  const seconds = Math.floor(currentTime.value % 60)
  return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`
})

const fullScreen = () => {
  videoPlayer.value.requestFullscreen()
}
const playVideo = () => {
  if(videoPlayer.value.paused) {
    videoPlayer.value.play()
    isPlaying.value = true
  } else {
    // 获取播放时长
    videoPlayer.value.pause()
    currentTime.value = parseInt(videoPlayer.value.currentTime)
    isPlaying.value = false
  }
}

</script>

<style lang="scss" scoped>
.credit-reform-container {
  width: 1285px;
  margin: 60px 0 130px;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    .main-title {
      color: #1C212A;
      font-family: "Alibaba PuHuiTi";
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
  }
  .main-content {
    display: flex;
    .left-content {
      width: 745px;
      height: 382px;
      position: relative;
      box-sizing: border-box;
      cursor: pointer;
      video {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        object-fit: fill;
      }
      .video-info {
        position: absolute;
        bottom: 24px;
        left: 28px;
        background-color: rgba($color: #000000, $alpha: 0.3);
        display: flex;
        align-items: center;
        padding: 8px 28px 8px 17px;
        border-radius: 20px;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
        span {
          color: #FFF;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 500;
          margin-left: 4px;
        }
      }
    }
    .right-content { 
      flex: 1;
      margin-left: 44px;
      .right-icon {
        width: 36px;
        height: 31px;
      }
      .right-title {
        color: #1C212A;
        font-family: "PingFang SC";
        font-size: 28px;
        font-weight: 600;
        margin-top: 40px;
      }
      .right-text {
        color: rgba(29, 33, 41, 0.9);
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 400;
        font-style: normal;
        line-height: 28px;
        margin-top: 76px;
        width: 486px;
      }
    }
  } 
}
</style>